import { useState } from 'react'
import { Button } from '@/common/ui/button'
import { GetOperatorMemberListTableData } from '@/modules/manage-member/type'
import Enable2FADialog from '@/modules/profile/components/Enable2FADialog'
import Disable2FADialog from '@/modules/profile/components/Disable2FADialog'
import useQueryProfile from '@/modules/auth/api/hooks/useQueryProfile'
import { PermissionKeys } from '@/modules/manage-member/mappers'

interface Manage2FAProps {
	row: GetOperatorMemberListTableData
}

export function Manage2FA({ row }: Manage2FAProps) {
	const [isEnableDialogOpen, setIsEnableDialogOpen] = useState(false)
	const [isDisableDialogOpen, setIsDisableDialogOpen] = useState(false)
	const { data: user } = useQueryProfile()

	const hasWritePermission = user?.userGroup.writePermission.includes(
		PermissionKeys.MANAGE_OPERATOR,
	)

	if (!hasWritePermission) {
		return null
	}

	return (
		<div>
			{row.totpEnabled ? (
				<>
					<Button
						variant="destructive"
						size="sm"
						onClick={() => setIsDisableDialogOpen(true)}
					>
						ปิดใช้งาน 2FA
					</Button>
					<Disable2FADialog
						open={isDisableDialogOpen}
						onOpenChange={setIsDisableDialogOpen}
						id={row.id}
					/>
				</>
			) : (
				<>
					<Button
						variant="outline"
						size="sm"
						onClick={() => setIsEnableDialogOpen(true)}
					>
						เปิดใช้งาน 2FA
					</Button>
					<Enable2FADialog
						open={isEnableDialogOpen}
						onOpenChange={setIsEnableDialogOpen}
						id={row.id}
					/>
				</>
			)}
		</div>
	)
}
